<script setup lang="ts">
import CommonTable from '@/components/common/table/CommonTable.vue'
import { useUploadStatusTable } from '@/composables/propertyTaxUpload/useUploadStatusTable'
import { FIELDS_TYPED } from '@/constants/ui/propertyTaxUpload/tableName'
import type { TableFields } from '@/types/component/common/table/commonTable'
import { UploadStatus, type UploadTableRow } from '@/types/aeroUpload/aeroUpload'
import { ref } from 'vue'

const { itemsTyped } = useUploadStatusTable()

const fieldsTyped = ref<TableFields<Partial<UploadTableRow>>>(FIELDS_TYPED)
</script>

<template>
  <div>
    <CommonTable :itemsTyped="itemsTyped" :fieldsTyped="fieldsTyped" class="fs-5 table">
      <template #cell(statusLabel)="{ row }">
        <span :class="{ 'text-danger': row.item.status === UploadStatus.WAIT }">
          {{ row.item.statusLabel }}
        </span>
      </template>
    </CommonTable>
  </div>
</template>

<style lang="scss" scoped>
.text-danger {
  color: red;
}
</style>
